import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class ControlDeposito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'pago/one', saveUrl: 'pago/save', backUrl: '/Cobranza/Pagos' },
      new Form([
        Form.Field('select', 'id_cuenta_bancaria', 'Cuenta', '', [Validators.required], 12),
        Form.Field('date', 'fecha_deposito', 'Fecha Deposito', '', [Validators.required], 12),
      ], ['Buscar'], 'Control de depositos'), this.formData
    )
    if (this.props.match.params.id) {
      this.LoadPreds();
    }
  }

  formData = async (form) => {
    const Res = await Http.get('pago/form');

    if (!Res.error) {
      const { CuentasBancarias } = Res.data;
      const newForm = Form.FieldOptions(form, 'id_cuenta_bancaria', CuentasBancarias, 'id', 'cuenta');
      return newForm;
    }
  }

  onSubmit = async (i, vals) => {
    vals.id = this.props.match.params.id;
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      const { id } = Res.data;
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
      this.props.onSave();
      this.props.history.push(`/Cobranza/DepositosDetalle/${id}`)
    }
    else
      this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });

  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ControlDeposito)
